import { useState } from "react";
import UnlockIcon from "./unlockIcon";
import { conditions } from "helpers";
import { ConditionName, IUnlockProps, zIndex } from "interfaces";
import { handleLock } from "redux-share/actions/controller.actions";
import dynamic from "next/dynamic";

const ControllbarTooltip = dynamic(() => import("../../mainComponent/footer/controllbar/controllbarTooltip"));

const Unlock = ({ inControllbar = false }: IUnlockProps) => {
    const [showTooltip, setShowTooltip] = useState<boolean>(false);

    return (
        <div className="pl-relative pl-flex pl-items-center">
            <UnlockIcon
                onClick={() => handleLock("lock")}
                onMouseOver={() => !conditions(ConditionName.isTouchScreen) && inControllbar && setShowTooltip(true)}
                onMouseLeave={() => !conditions(ConditionName.isTouchScreen) && inControllbar && setShowTooltip(false)}
                style={{ zIndex: zIndex.lockIcon }}
            />
            {showTooltip && <ControllbarTooltip title="قفل (l)" className="pl-right-[-15px]" />}
        </div>
    );
};

export default Unlock;
